// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"92f43b2a","98":"2aecfd84","140":"19aee1a9","372":"575a8962","488":"715adda9","520":"460f0605","823":"9e5cf87e","912":"3eb88d5e"}[chunkId] + ".chunk.js";
};